import { DialogTitle, Link, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import React, { ReactElement, useId } from 'react'
import PopoverCloseButton from 'ui/components/PopoverCloseButton/PopoverCloseButton'
import Tooltip from 'ui/components/Tooltip/Tooltip'

type CopyDialogTitleProps = {
  title: string | ReactElement
  infoText?: string | React.ReactNode
  style?: React.CSSProperties
  paddingBottom?: string
  handleClose: () => void
  onTitleClick?: () => void
  titleTooltip?: string
  fontSize?: number
}

export default function CopyDialogTitle({
  title,
  handleClose,
  infoText: infoText,
  style,
  paddingBottom = '14px',
  onTitleClick,
  titleTooltip,
  fontSize,
}: CopyDialogTitleProps): ReactElement {
  const uniqueId = useId()

  const titleContent = (
    <Link
      style={{ textDecoration: 'none', color: 'inherit', cursor: onTitleClick ? 'pointer' : 'inherit' }}
      onClick={(e) => {
        if (onTitleClick) {
          e.preventDefault()
          onTitleClick()
        }
      }}
    >
      {title}
    </Link>
  )

  return (
    <DialogTitle
      id={`form-dialog-title-${uniqueId}`}
      sx={{
        paddingBottom: paddingBottom,
      }}
    >
      <Grid
        container
        alignItems="flex-start"
        justifyContent="space-between"
        direction="row"
        wrap="nowrap"
        style={style}
      >
        <Typography
          variant="h2"
          style={{ fontWeight: 'bold', fontSize: fontSize }}
          sx={{ flex: '1 1 auto', minWidth: 0, overflowWrap: 'anywhere' }}
          display="inline"
          alignSelf="center"
        >
          {titleTooltip ? (
            <Tooltip title={titleTooltip} arrow placement="bottom">
              {titleContent}
            </Tooltip>
          ) : (
            titleContent
          )}
        </Typography>
        <Typography variant="h3" alignSelf="center" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
          {infoText}
        </Typography>
        <div className="shrink-0">
          <PopoverCloseButton handleClose={handleClose} />
        </div>
      </Grid>
    </DialogTitle>
  )
}
